import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentInfoService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(private http: HttpClient, private UTS: UtilitiesService) {}

  getUserPayment() {
    var getUserPaymentInput = {};
    return this.http.post(
      environment.ECARE_URL+'/eshop/getPaymentServices.service',
      getUserPaymentInput,
      this.httpOptions
    );
  }
  deletePaymentMethods(accountId) {
    var deletePaymentMethodsInput = { accountNumber: accountId };
    return this.http.post(
      environment.ECARE_URL+
      'deletePaymentMethods.service',
      deletePaymentMethodsInput,

      this.httpOptions
    );
  }
  storePaymentInfo(paymentGroups) {
    return this.http.post(
      environment.ECARE_URL + '/eshop/storePaymentInfo',
      paymentGroups
    );
  }

  getPaymentInfo() {
    return this.http.get(environment.ECARE_URL + '/eshop/getPaymentInfo');
  }

  getUserAccounts() {
    let getUserAccountsInput = {};
    return this.http.post(
      environment.ECARE_URL+
      '/getAllAccountServices.service',
      getUserAccountsInput,

      this.httpOptions
    );
  }
  getUserAccountsStub() {
    return this.http
      .get(
        environment.ECARE_URL +
          '/eshopApp/assets/offlineData/elife/AllAccount.json'
      )
  }
  getAccountSummary(accountId) {
    let getAccountSummaryInput = { accountNumber: accountId };
    return this.http.post(
      environment.ECARE_URL+
      '/getAccSummary.service',
      getAccountSummaryInput,

      this.httpOptions
    );
  }
  getSmilePointEquivalency(tranactionCategory) {
    let getSmilePointEquivalencyInput = {
      tranactionCategory: tranactionCategory,
    };
    return this.http.post(
      environment.ECARE_URL+
      '/smileAmountEquivalency.service',
      getSmilePointEquivalencyInput,

      this.httpOptions
    );
  }

  getEshopConfigurations() {
    return this.http.post(
      environment.ECARE_URL + '/eshopConfigurations.service',
      {}
    );
  }
}
